export const preventDefault = (e: React.SyntheticEvent<unknown>) =>
    e.preventDefault()
export const stopPropagation = (e: React.SyntheticEvent<unknown>) =>
    e.stopPropagation()
